import React from 'react';
import Table, { TableCell } from '..';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import RichText from '../../RichText';
import { TableContainer } from './styles';

export type HeaderCell = {
  headingText: string;
  columnSpan: number;
};

export type HeaderRow = {
  hasCornerHeadingGap: boolean;
  cornerCellColumnSpan: number;
  headerCells: HeaderCell[];
};

export type ContentCell = {
  cell: {
    contentRichText: string;
    columnSpan: number;
    isHighlighted?: boolean;
  };
};

export type ContentRow = {
  contentRow: {
    cells: ContentCell[];
  };
};

export type SimpleTableProps = {
  table: {
    headerRow?: HeaderRow;
    contentRows: ContentRow[];
  };
} & ComponentProps;

const SimpleTable: React.FC<SimpleTableProps> = ({ table, ...props }) => (
  <TableContainer {...componentProps(props)}>
    <Table hasCornerHeadingGap={table.headerRow?.hasCornerHeadingGap}>
      {table.headerRow && (
        <thead>
          <tr>
            {table.headerRow.hasCornerHeadingGap &&
              table.headerRow.cornerCellColumnSpan && (
                <TableCell colSpan={table.headerRow.cornerCellColumnSpan} />
              )}
            {table.headerRow.headerCells.map((cell, index) => (
              <TableCell key={index} colSpan={cell.columnSpan} isHeader>
                <RichText html={cell.headingText} />
              </TableCell>
            ))}
          </tr>
        </thead>
      )}
      <tbody>
        {table.contentRows.map((row, index) => (
          <tr key={index}>
            {row.contentRow.cells.map((cells, cellsIndex) => (
              <TableCell
                key={cellsIndex}
                colSpan={cells.cell.columnSpan}
                highlight={cells.cell.isHighlighted}>
                <RichText html={cells.cell.contentRichText} />
              </TableCell>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  </TableContainer>
);

export default applyComponentTheme(SimpleTable, 'SimpleTable');
